enum WidgetFieldNames {
  ActiveInterventionsInfo = 'activeInterventionsInfo',
  AnnouncementAppearanceTitle = 'announcementAppearanceTitle',
  AnnouncementBoxColor = 'announcementBoxColor',
  AnnouncementDescription = 'announcementDescription',
  AnnouncementEndAt = 'announcementEndAt',
  AnnouncementImage = 'announcementImage',
  AnnouncementInfo = 'announcementInfo',
  AnnouncementMessageContent = 'announcementMessageContent',
  AnnouncementScheduleTitle = 'announcementScheduleTitle',
  AnnouncementStartAt = 'announcementStartAt',
  AnnouncementTitle = 'announcementTitle',
  Categories = 'categories',
  ClockInfo = 'clockInfo',
  Color = 'color',
  DeadlineTrackerInfo = 'deadlineTrackerInfo',
  ExternalLinkDesc = 'externalLinkDesc',
  ExternalLinkDescription = 'externalLinkDescription',
  ExternalLinkInfo = 'externalLinkInfo',
  ExternalLinkTitle = 'externalLinkTitle',
  ExternalUrl = 'externalUrl',
  Icon = 'icon',
  MaxItems = 'maxItems',
  Priority = 'priority',
  QuickCreationEquipment = 'quickCreationEquipment',
  QuickCreationFormTemplate = 'quickCreationFormTemplate',
  QuickCreationInfo = 'quickCreationInfo',
  QuickCreationIntervention = 'quickCreationIntervention',
  QuickCreationSite = 'quickCreationSite',
  QuickCreationTask = 'quickCreationTask',
  QuickCreationTeamMember = 'quickCreationTeamMember',
  QuickCreationToggles = 'quickCreationToggles',
  RefreshInterval = 'refreshInterval',
  SectorIds = 'sectorIds',
  SectorsDeadlineTrackerInfo = 'sectorsDeadlineTrackerInfo',
  ShowClosed = 'showClosed',
  ShowOnlyMyInterventions = 'showOnlyMyInterventions',
  SiteIds = 'siteIds',
  SitesDeadlineTrackerInfo = 'sitesDeadlineTrackerInfo',
  SitesMapInfo = 'sitesMapInfo',
  Timezone = 'timezone',
  WeatherTodayInfo = 'weatherTodayInfo',
  WeatherTodayLocation = 'weatherTodayLocation',
  WeatherWeekInfo = 'weatherWeekInfo',
  WeatherWeekLocation = 'weatherWeekLocation',
  Widget = 'widget',
}

export default WidgetFieldNames;
